import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import { currencyFormat, formatTimeUnit } from '../../../../../../../Apis/functions';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Detail modal for the base salary leading row. No table: the values are laid
 * out as label/value rows following the same structure as PayrollLinesColumn
 * (label on the left, value on the right, with a bottom divider per row).
 *
 * @param {boolean} show - Controls modal visibility.
 * @param {Function} onHide - Callback to close the modal.
 * @param {Object} item - Base salary snapshot (amounts and minute fields).
 */

// A single label/value row mirroring PayrollLineRow's layout. `total` emphasizes
// the row (bold text and a thicker divider) like the column's total row.
const InfoRow = ({ label, value, total = false }) => (
    <div>
        <div className='row g-0 flex-nowrap align-items-center'>
            <div className='col me-2 minw-0'>
                <p className={`fs-14px mb-0 font-color-general-950 ${total ? 'ibl-font-w-700' : 'ibl-font-w-600'}`}>{label}</p>
            </div>
            <div className={`col-auto fs-14px text-end font-color-general-950 ${total ? 'ibl-font-w-700 ' : 'ibl-font-w-500'}`}>{value}</div>
        </div>
        <div className={`${total ? '' : 'border-bottom-shades-300'} my-1`}/>
    </div>
);

const BaseSalaryModal = ({ show, onHide, item }) => {
    const { t } = useTranslation();

    const rows = [
        { label: t('regular_hours'), value: formatTimeUnit(item?.totalWorkedMinutes) },
        { label: t('hourly_rate'), value: `$${currencyFormat(item?.hourlyRate)}` },
        {
            label: t('base_salary_formula'),
            value: `${formatTimeUnit(item?.totalWorkedMinutes)} x $${currencyFormat(item?.hourlyRate)}`,
        },
    ];

    return (
        <CustomModal
            title={'base_salary_breakdown'}
            show={show}
            size='md'
            onHide={onHide}
            onClose={onHide}
            cancelButton={false}
            confirmButton={false}
        >
            {rows.map(({ label, value }, i) => (
                <InfoRow key={i} label={label} value={value} />
            ))}
            <InfoRow label={t('base_salary')} value={`$${currencyFormat(item?.baseSalary)}`} total />
        </CustomModal>
    );
};

export default BaseSalaryModal;
